import React, { useMemo } from 'react'
import { Modal } from 'reactstrap'
import { useTranslation } from 'react-i18next'

import ava from 'Shared/img/ava.png'
import { Curator } from 'src/Types'
import Toggle from './Toggle'

export interface CuratorModelProps {
  modal: boolean
  curator: Curator
  addingRate: number
  toggle: () => void
  t: (text: string) => string
  handleCuratorChangeAutopay: (curator_id: number, autopay: boolean) => void
}

const CuratorDetailModal: React.FunctionComponent<CuratorModelProps> = ({
  toggle,
  modal,
  addingRate,
  curator: {
    id,
    first_name,
    last_name,
    email,
    autopay,
    negative_responses,
    Playlists,
    user_photo_url,
    username,
    spotify_id,
  },
  handleCuratorChangeAutopay,
}) => {
  const { t } = useTranslation()

  const playlists_followers = useMemo(
    () => Playlists && Playlists.map(playlist => playlist.followers).join(', '),
    [Playlists]
  )

  return (
    <div>
      <Modal
        fade={false}
        className="modal-dialog--success modal-dialog--header"
        isOpen={modal}
        modalClassName="ltr-support"
        toggle={toggle}
      >
        <div className="modal__header">
          <button
            className="lnr lnr-cross modal__close-btn"
            type="button"
            onClick={toggle}
          />
          <h4 className="text-modal  modal__title">
            {t('adminPage.infoModalTitle')}
          </h4>
        </div>
        <div className="modal-dialog__inner-wrapper">
          <div className="modal-dialog__user-info-header">
            <img
              className="modal-dialog__userpic"
              src={user_photo_url || ava}
              alt=""
            />
            <div className="modal-dialog__name-container">
              <span>{`${first_name} ${last_name && last_name}`}</span>
              <span>{`${email}`}</span>
            </div>
          </div>

          <div>
            <h2 className="modal-dialog__subtitle">
              {t('adminPage.infoModalDetails')}
            </h2>
            <ul className="modal-dialog__list">
              <li className="modal-dialog__list-item">
                <span className="modal-dialog__value-name">
                  {t('adminPage.infoModalProfileName')}
                </span>
                <a
                  className="modal-dialog__link"
                  href={`https://open.spotify.com/user/${spotify_id}`}
                  target="blank"
                >
                  <span className="modal-dialog__value modal-dialog__value--underline">
                    {username
                      ? `${username}`
                      : `${first_name} ${last_name && last_name}`}
                  </span>
                </a>
              </li>
              <li className="modal-dialog__list-item">
                <span className="modal-dialog__value-name">
                  {t('adminPage.infoModalPlaylistFollowers')}
                </span>
                <span className="modal-dialog__value">
                  {playlists_followers}
                </span>
              </li>
              <li className="modal-dialog__list-item">
                <span className="modal-dialog__value-name">
                  {t('adminPage.infoModalNegativeResponses')}
                </span>
                <span className="modal-dialog__value modal-dialog__value--alert">
                  {negative_responses}
                </span>
              </li>
              <li className="modal-dialog__list-item">
                <span className="modal-dialog__value-name">
                  {t('adminPage.infoModalAddingRate')}
                </span>
                <span className="modal-dialog__value">{`${addingRate} %`}</span>
              </li>
              <li className="modal-dialog__list-item modal-dialog__list-item--toggle">
                <span className="modal-dialog__value-name">
                  {t('adminPage.infoModalAutopayoutStatus')}
                </span>
                <Toggle
                  id={id}
                  isChecked={!!autopay}
                  onChange={() => {
                    handleCuratorChangeAutopay(id, autopay)
                  }}
                />
              </li>
            </ul>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default CuratorDetailModal
